import React from 'react';
import Apps from "../../components/Apps/Apps";
import './HomePage.css'
const HomePage = () => {
    return (
        <div className="homePage">
            <Apps/>
        </div>
    );
};

export default HomePage;